/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeChangelogDescriptionResponse,
  ApiEnvelopeChangelogSetResponse,
  ApiEnvelopeChangelogVersionsResponse,
  GetChangelogDescriptionRequest,
  SetChangelogRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type changelogGetDescriptionResponse200 = {
  data: ApiEnvelopeChangelogDescriptionResponse
  status: 200
}

export type changelogGetDescriptionResponse400 = {
  data: ApiEnvelopeChangelogDescriptionResponse
  status: 400
}

export type changelogGetDescriptionResponseSuccess = (changelogGetDescriptionResponse200) & {
  headers: Headers;
};
export type changelogGetDescriptionResponseError = (changelogGetDescriptionResponse400) & {
  headers: Headers;
};

export type changelogGetDescriptionResponse = (changelogGetDescriptionResponseSuccess | changelogGetDescriptionResponseError)

export const getChangelogGetDescriptionUrl = () => {




  return `/api/Changelog/Description`
}

export const useChangelogGetDescriptionHook = (): (getChangelogDescriptionRequest?: GetChangelogDescriptionRequest, options?: RequestInit) => Promise<changelogGetDescriptionResponse> => {

      const customFetcher = useSfetchMutator();
      return (getChangelogDescriptionRequest?: GetChangelogDescriptionRequest, options?: RequestInit) => {

        return customFetcher(getChangelogGetDescriptionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(getChangelogDescriptionRequest)
  }
);
      }
  }


export type changelogGetVersionsResponse200 = {
  data: ApiEnvelopeChangelogVersionsResponse
  status: 200
}

export type changelogGetVersionsResponse400 = {
  data: ApiEnvelopeChangelogVersionsResponse
  status: 400
}

export type changelogGetVersionsResponseSuccess = (changelogGetVersionsResponse200) & {
  headers: Headers;
};
export type changelogGetVersionsResponseError = (changelogGetVersionsResponse400) & {
  headers: Headers;
};

export type changelogGetVersionsResponse = (changelogGetVersionsResponseSuccess | changelogGetVersionsResponseError)

export const getChangelogGetVersionsUrl = () => {




  return `/api/Changelog/Versions`
}

export const useChangelogGetVersionsHook = (): ( options?: RequestInit) => Promise<changelogGetVersionsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getChangelogGetVersionsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type changelogPostChangelogResponse200 = {
  data: ApiEnvelopeChangelogSetResponse
  status: 200
}

export type changelogPostChangelogResponse400 = {
  data: ApiEnvelopeChangelogSetResponse
  status: 400
}

export type changelogPostChangelogResponseSuccess = (changelogPostChangelogResponse200) & {
  headers: Headers;
};
export type changelogPostChangelogResponseError = (changelogPostChangelogResponse400) & {
  headers: Headers;
};

export type changelogPostChangelogResponse = (changelogPostChangelogResponseSuccess | changelogPostChangelogResponseError)

export const getChangelogPostChangelogUrl = () => {




  return `/api/Changelog`
}

export const useChangelogPostChangelogHook = (): (setChangelogRequest?: SetChangelogRequest, options?: RequestInit) => Promise<changelogPostChangelogResponse> => {

      const customFetcher = useSfetchMutator();
      return (setChangelogRequest?: SetChangelogRequest, options?: RequestInit) => {

        return customFetcher(getChangelogPostChangelogUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setChangelogRequest)
  }
);
      }
  }


